import { useState, useEffect, useRef } from "react";
import RechargeCardView from "./view";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useDispatch, useSelector } from "react-redux";
import {
  getCustomerData,
  paymentSavedCard,
  setCustomer,
} from "@/redux/ducks/customer";
import useCybersourceService from "@/hooks/useCybersourceService";

export default function RechargeCard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const { getSessionId } = useCybersourceService();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const hasTriggered = useRef(false);

  const goBack = () => navigate("/payment");

  const handleCard = (success: boolean, data?: { sqPagamento?: string }) => {
    setIsLoading(false);

    if (!success) {
      setError(true);
      return;
    }

    if (data?.sqPagamento) {
      dispatch(setCustomer({ sqPagamento: data.sqPagamento }));
    }

    dispatch(getCustomerData());
    navigate("/payment/finished");
  };

  const recharge = () => {
    if (isLoading) return;

    if (!customer?.account?.card?.cardNumber) {
      navigate("/payment/creditCard");
      return;
    }

    setIsLoading(true);
    setError(false);

    const visitorId = getSessionId();

    dispatch(
      paymentSavedCard({
        visitorId: visitorId!,
        callback: handleCard,
      }),
    );
  };

  const dismissError = () => {
    setError(false);
    goBack();
  };

  useEffect(() => {
    if (!hasTriggered.current) {
      hasTriggered.current = true;
      recharge();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RechargeCardView
      isLoading={isLoading}
      error={error}
      goBack={goBack}
      payment={recharge}
      dismissError={dismissError}
    />
  );
}
